"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSettingsToGql = exports.mapSettingsToVod = void 0;
const pricing_1 = require("../../mappers/pricing");
const mapSettingsToVod = (settings) => {
    const { defaultChannelId, defaultPricing, currency, embedLogos, extendOptions, } = settings;
    return Object.assign({ defaultChannelId,
        currency, dealInfo: defaultPricing.map(pricing_1.mapSettingsPricingToVod), embedLogos: embedLogos.default.map((url) => ({
            url,
            id: url,
        })), embedDefaultLogoId: embedLogos.selected }, extendOptions);
};
exports.mapSettingsToVod = mapSettingsToVod;
const mapSettingsToGql = (settings) => {
    const variables = {
        currency: settings.currency,
        defaultChannelId: settings.defaultChannelId,
        defaultPricing: settings.dealInfo.map(pricing_1.mapSettingsPricingToGql),
        embedLogos: settings.embedLogos.map(({ url }) => url),
        selectedEmbedLogo: settings.embedDefaultLogoId,
        extendOptions: {},
    };
    Object.keys(settings).forEach((key) => {
        if (key in variables) {
            return;
        }
        if (key === 'dealInfo') {
            return;
        }
        variables.extendOptions[key] = settings[key];
    });
    return variables;
};
exports.mapSettingsToGql = mapSettingsToGql;
//# sourceMappingURL=settings.mappers.js.map